import {api} from "@/app/services/api.service";

const state = {
    non_individuals: null,
    non_individuals_scheduled: null,
    escalations: [],
    non_individualStatuses: null,
    non_individual_task: {},
    non_individual_task_error: null,
    non_individual_details: null,
    non_individual_stats: {},
    non_individual_count: {},
    success: {},
    successAssignmentDr: {},
    disputeSuccessEscalation: {},
    errorAssignment: {},
    successStatusUpdate: {},
    dispute_error: null,
};

const getters = {
    getNonIndividualSubmissions: (state) => state.non_individuals,
    getScheduledNonIndividualSubmissions: (state) => state.non_individuals_scheduled,
    getNonIndividualEscalations: (state) => state.escalations,
    getNonIndividualTask: (state) => state.non_individual_task,
    getNonIndividualTaskError: (state) => state.non_individual_task_error,
    getNonIndividualDetails: (state) => state.non_individual_details,
    getNonIndividualStatistics: (state) => state.non_individual_stats,
    getNonIndividualStatuses: (state) => state.non_individualStatuses,
    getNonIndividualStatusUpdate: (state) => state.successStatusUpdate,
    getNonIndividualCount: (state) => state.non_individual_count,
    getNonIndividualSuccess: (state) => state.success,
    getNonIndividualEscalationSuccess: (state) => state.disputeSuccessEscalation,
    getNonIndividualAssignmentSuccess: (state) => state.successAssignmentDr,
    getNonIndividualAssignmentError: (state) => state.errorAssignment,
    getNonIndividualError: (state) => state.dispute_error,
    getNonIndividualEscalationError: (state) => state.dispute_error,
};

const actions = {
    async submitNonIndividualApplicationPayment({commit}, data) {
        await api().post("/nir/api/v1/non-individual/disputes/add-payment", data)
            .then((response) => {
                commit("setNonIndividual", response.data);
            })
            .catch((error) => {
                commit("setNonIndividualTaskError", error.response);
            });
    },
    async fetchNonIndividualSubmissions({commit}, data) {
        let path =
          "/applications?status=" +
          data.statuses +
          "&page=" +
          data.page +
          "&limit=" +
          data.limit;
        if (data.search !== "") {
            path += "&search=" + data.search
        }
        api()
          .get("/nir/api/v1/" + path)
          .then(response => {
            commit("setNonIndividuals", response.data);
          })
          .catch(error => {
            commit("setNonIndividualError", error.response);
          });
    },
    async fetchNonIndividualEscalations({commit}, data) {
        api().get("/nir/api/v1/applications/escalations?userId=" + data.userId + "&page=" + data.page + "&perPage=" + data.limit).then(response => {
            commit('setCFEscalations', response.data);
        }).catch(error => {
            commit("setNonIndividualEscalationError", error.response)
        });
    },
    async fetchNonIndividualStatuses({commit}, id) {
        api().get("/nir/api/v1/non-individual/non-individuals/tasks/" + id + "/thread").then(response => {
            commit('setNonIndividualStatuses', response);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    async fetchNextNonIndividual({commit},userId ) {
        commit('setNonIndividualToNull');
        let url = "nir/api/v1/applications/next?userId="+userId;

        api().get(url).then(response => {
            commit('setNonIndividual', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    async fetchNonIndividualDetails({commit}, trackingNumber) {
        api()
          .get(
            "/nir/api/v1/applications/task?id=" + trackingNumber
          )
          .then(response => {
            commit("setNonIndividualDetails", response.data);
          })
          .catch(error => {
            commit("setNonIndividualError", error.response);
          });
    },
    async fetchNonIndividualStats({commit}) {
        api()
          .get("/nir/api/v1/applications/stats")
          .then(response => {
            commit("setNonIndividualStats", response.data);
          })
          .catch(error => {
            commit("setNonIndividualError", error.response);
          });
    },
    async fetchNonIndividualCount({commit}) {
        api().get("/nir/api/v1/non-individual/non-individuals/tasks/count").then(response => {
            commit('setNonIndividualCount', response);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    updateNonIndividualStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/tasks/" + data.id+"/task",     {status: data.status,
            rationale:data.rationale
    }).then(response => {
            commit('setNonIndividualStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAssignmentError", error.response)
        });
    },
    approveNonIndividualApplication({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/tasks/" + data.get("id") + "/receive", data).then(response => {
            commit('setNonIndividualStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAssignmentError", error.response)
        });
    },
    queryNonIndividualChargeStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/queue/query-for-payment", data).then(response => {
            commit('setNonIndividualStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAssignmentError", error.response)
        });
    },
    rejectNonIndividualChargeStatus({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/queue/query-for-payment", data).then(response => {
            commit('setNonIndividualStatusUpdated', response.data);
        }).catch(error => {
            commit("setNonIndividualAssignmentError", error.response)
        });
    },
    assignNonIndividualTask({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/tasks/assign-task", data).then(response => {
            commit('setNonIndividualAssignmentAction', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    assignEscalationNonIndividualTask({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/escalation/queue/re-assign", data).then(response => {
            commit('setNonIndividualAssignmentAction', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    escalateNonIndividualTask({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/tasks/"+data.taskId+"/escalate", data).then(response => {
            commit('setNonIndividualEscalationAction', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    reEscalateNonIndividualTask({commit}, data) {
        api().post("/nir/api/v1/non-individual/non-individuals/queue/escalate", data).then(response => {
            commit('setNonIndividualEscalationAction', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
    async fetchScheduledNonIndividuals({commit}, data) {
        let path = "/nir/api/v1/non-individual/scheduled/events?status=" + data.statuses + "&page=" + data.page + "&size=" + data.limit +"&type="+data.type
    /*    if (data.search) {
            path += "&search=" + data.search
        }*/
        api().get(path).then(response => {
            commit('setScheduledNonIndividuals', response.data);
        }).catch(error => {
            commit("setNonIndividualError", error.response)
        });
    },
};

const mutations = {
    setNonIndividuals: (state, response) => {
        state.non_individuals = response.data;
    }, setScheduledNonIndividuals: (state, response) => {
        state.non_individuals_scheduled = response;
    },
    setCFEscalations: (state, response) => {
        state.escalations = response;
    },
    setNonIndividual: (state, response) => {
        state.non_individual_task = response;
    },
    setNonIndividualTaskError: (state, error) => {
        state.non_individual_task_error = error;
    },
    setNonIndividualDetails: (state, response) => {
        state.non_individual_details = response;
    },
    setNonIndividualToNull: (state) => {
        state.non_individual = null;
    },
    setNonIndividualStatuses: (state, response) => {
        state.non_individualStatuses = response.data;
    },
    setNonIndividualStats: (state, response) => {
        state.non_individual_stats = response.data;
    },
    setNonIndividualCount: (state, response) => {
        state.non_individual_count = response.data;
    },
    setNonIndividualAction: (state, response) => {
        state.success = response;
    },
    setNonIndividualAssignmentAction: (state, response) => {
        state.successAssignmentDr = response;
    },
    setNonIndividualStatusUpdated: (state, response) => {
        state.successStatusUpdate = response;
    },
    setNonIndividualEscalationAction: (state, response) => {
        state.disputeSuccessEscalation = response;
    },
    setNonIndividualError: (state, error) => {
        state.dispute_error = error.data;
    },
    setNonIndividualEscalationError: (state, error) => {
        state.dispute_error = error.data;
    },
    setNonIndividualAssignmentError: (state, error) => {
        state.errorAssignment = error;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};